import React, { useState } from "react";
import logo from "../../../../../../../assets/logos/golden-logo.png";
import Button from "../../../../../../common/Button/Button";
import InputFormik from "../../../../../../common/Formik/Input/InputFormik";
import Select from "../../../../../../common/Formik/Select/Select";
import styles from "../Buy/Buy.module.scss";
import SellConfirm from "../../../../../../common/Modals/SellConfirm/SellConfirm";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { Messages, FORMIK_REGEX } from "../../../../../../../utils/constants";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import silver from "../../../../../../../assets/logos/silver-logo.png";
import { getSpotPriceAction } from "../../../../../../../features/user/userSlice";
import { getTokenBalanceAction } from "../../../../../../../features/user/userSlice";
import { createBuyOrderAction } from "../../../../../../../features/user/userSlice";
import PaymentCompleted from "../../../../../../common/Modals/PaymentCompleted/PaymentCompleted";
import { validationMessage } from "../../../../../../../Helper/helperfunction";
import { toFix } from "../../../../../../../utils/utils";

const Sell = () => {
  const dispatch = useDispatch();
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );
  const tokenBalance = useSelector((state) => state?.users?.tokenBalance);
  const userData = useSelector((state) => state?.persist?.userInfo);
  const [total, setTotal] = useState(0);
  const [show, setShow] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [showCompleted, setShowCompleted] = useState(false);
  let patternFourDigitsAfterComma = /^\d+(\.\d{0,4})?$/;

  const assetOptions = [
    {
      label: "Gold STBL",
      icon: logo,
      value: 1,
      symbol: "XAU/USD",
    },
    {
      label: "Silver STBL",
      icon: silver,
      value: 2,
      symbol: "XAG/USD",
    },
  ];
  const [tokenObj, setTokenObj] = useState(assetOptions[0]);

  const sellValidationSchema = Yup.object({
    quantity: Yup.string()
      .required(validationMessage("Quantity"))
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION)
      // .test("is-decimal", "four decimal places allowed", (val) => {
      //   if (val !== undefined) {
      //     return patternFourDigitsAfterComma.test(val);
      //   }
      //   return true;
      // })
      .test("checkBalance", "Quantity exceeds token balance!", (val) => {
        if (val > Number(tokenBalance)) {
          return false;
        }
        return true;
      }),
    amount: Yup.string()
      .required(validationMessage("Amount"))
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: "",
      amount: "",
      tokenId: assetOptions[0].value,
      tokenName: assetOptions[0].label,
      orderType: "SELL",
      price: "",
    },
    validationSchema: sellValidationSchema,
    onSubmit: async (values) => {
      if (!values.quantity || !values.amount) {
        return;
      }

      if (formik.isValid) {
        setShow(true);
      }
    },
  });

  const getBalance = async (data) => {
    try {
      const params = {
        tokenId: tokenObj?.value,
      };
      await dispatch(getTokenBalanceAction(params));
    } catch (error) {
      console.log("error", error);
    }
  };

  const getSpotPrice = async (data) => {
    try {
      const params = {
        symbol: tokenObj?.symbol,
      };
      const response = await dispatch(getSpotPriceAction(params));
      if (response.status === 200) {
        formik.setFieldValue("amount", response?.data?.data?.Ask);
        formik.setFieldValue("price", response?.data?.data?.Ask);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getSpotPrice();
    getBalance();
  }, [tokenObj]);

  const handleSellConfirm = async () => {
    try {
      formik.setFieldValue("type", paymentType);
      const response = await dispatch(createBuyOrderAction(formik.values));
      const params = {
        tokenId: tokenObj?.value,
      };
      if (response.status === 200) {

        // Partnero Transaction Tracking
        if (window.po && typeof window.po === "function") {
          console.log("Partero tracking initiated for transaction:", {
            transactionId: response.data.data.transactionId,
            userEmail: userData?.email,
            totalAmount: Number(formik.values.amount * formik.values.quantity),
          });

          try {
            const partneroData = {
              data: {
                key: response.data.data.transactionId, // Transaction ID
                amount: Number(formik.values.amount), // Total amount
                amount_units: "usd", // Currency code
                customer: {
                  key: userData?.email, // User identifier
                },
              },
            };


            window.po("transactions", "create", partneroData);

          } catch (error) {
            console.error("Error during Partnero transaction tracking:", {
              error: error.message,
              transactionId: response.data.data.transactionId,
              userEmail: userData?.email,
              totalAmount: Number(formik.values.amount * formik.values.quantity),
            });
          }
        } else {
          console.warn("⚠️ Partnero 'po' function not found on window. Ensure Partnero script is loaded.");
        }

        await dispatch(getTokenBalanceAction(params));
        setShow(false);
        setShowCompleted(true);
        getSpotPrice();
        formik.resetForm({ ...formik.initialValues });
      }
    } catch (error) {
      console.error("Error placing sell order:", {
        error: error.message,
        stack: error.stack,
        formData: JSON.stringify(formik.values, null, 2),
      });
    }
  };

  const handleAssetChange = (selected) => {
    formik.resetForm();
    setTokenObj(selected);
    formik?.setFieldValue("tokenId", selected?.value);
    formik?.setFieldValue("tokenName", selected?.label);
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    formik.setFieldValue("quantity", value);
  };

  useEffect(() => {
    const total =
      isNaN(formik.values.quantity) || isNaN(formik.values.amount)
        ? 0
        : formik.values.quantity * formik.values.amount;
    setTotal(total.toFixed(2));
  }, [formik.values.quantity, formik.values.amount]);

  return (
    <div className={styles.buy_module}>
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <div className={`${styles.buy_module_asset} ${styles.mb_7}`}>
          <div className={styles.buy_module_asset_header}>
            <h6 className={styles.select_asset}>Select Asset</h6>
            <h6 className={styles.balance}>
              Bal: <span>{toFix(Number(tokenBalance), 3)} ozt</span>
            </h6>
          </div>
          <Select
            options={assetOptions}
            variant="dark large_height"
            isSearchable={false}
            defaultValue={assetOptions[0]}
            onChange={(selected) => handleAssetChange(selected)}
          />
        </div>
        <div className={`${styles.qty} ${styles.mb_7}`}>
          <InputFormik
            id="quantity"
            name="quantity"
            label="Quantity"
            variant="dark"
            className={styles.qty_input}
            iconClassName={styles.current_qty}
            placeholder="100.00"
            formik={formik}
            onChange={handleQuantityChange}
            onBlur={formik.handleBlur}
            // value={formik?.values?.quantity}
            value={
              formik.values.quantity ? `${formik.values.quantity} ozt` : ""
            }
            maxLength={10}
          />
        </div>
        <div className={`${styles.amount} ${styles.mb_7}`}>
          <InputFormik
            label="Price"
            name="amount"
            variant="dark"
            placeholder="Your Selling Price"
            formik={formik}
            onChange={(e) => {
              formik.handleChange(e);
              formik.setFieldValue("price", e.target.value);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.amount}
            className={styles.amount_input}
            maxLength={10}
            disabled
          />
        </div>
        <div className={`${styles.total_text} ${styles.mb_16}`}>
          <h6>Total</h6>
          <h4>{total}</h4>
        </div>
        <Button
          disabled={kycStatus !== "APPROVED"}
          variant="yellow_btn"
          fluid
          type="button"
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          Sell {tokenObj?.label}
        </Button>
        <SellConfirm
          show={show}
          sellData={formik.values}
          handleClose={() => setShow(false)}
          handleSellConfirm={handleSellConfirm}
          setPaymentType={setPaymentType}
          title={`Sell ${tokenObj?.label} for USD`}
        />
        <PaymentCompleted
          show={showCompleted}
          handleClose={() => setShowCompleted(false)}
          paymentType="SELL"
        />
      </form>
    </div>
  );
};

export default Sell;